module.exports = __webpack_public_path__ + "img/h13-min.66a84c91.png";